export const baseurl = 'https://digitalize.aiyd88.com'

export const appid = 'wx69af75838a8482da'

export const component_appid = ''

export const uniacid = '124'
